export const SET_ENTITIES = 'SET_ENTITIES';

export const SET_OPTIONS = 'SET_OPTIONS';

export const SET_ENTITY = 'SET_ENTITY';

export const REMOVE_ENTITY = 'REMOVE_ENTITY';

export const CLEAR_BILLING = 'CLEAR_BILLING';